define.alias("shared/helpers/format-datetime", "calendar/helpers/format-datetime");